import { inject, Injectable } from '@angular/core';

import { CreateFormat, Format } from '@celum/formats/domain';

import { FormatStore } from '../store';
import { FormatFormServiceBase } from './format-form-service-base';
import { FORMAT_SERVICE } from './formats.service';

export { buildParametersPayload, partitionParameterValues, assignNestedValue, resolveSavedValue, resolveDefaultValue } from './format-form-service-base';

@Injectable()
export class FormatFormService extends FormatFormServiceBase<Format, CreateFormat> {
  protected override readonly formatStore = inject(FormatStore);
  protected override readonly formatDefinitionsService = inject(FORMAT_SERVICE);
  protected override readonly logPrefix = 'FormatFormService';

  public generateFormatObject(): CreateFormat {
    const common = this.buildCommonFormatFields();
    return common as CreateFormat;
  }
}
